module.exports = __webpack_public_path__ + "img/lv_success_5.b3ce412c.png";